/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { VodPlayActionError } from '../error';
import { TVodWatchAction } from './TActionDetailsList';

export type VodRequiredParams = {
    id: string;
    partnerId: string;
    contentSupplierPartnerId?: string;
    isPreview?: boolean;
} & (
    | { itemType: 'offer' }
    | { itemType: 'content' | 'unifiedCollection'; collapsedVodItemId: string }
);

export const TVodPlayActionStateType = {
    INIT: 'INIT',
    ERROR: 'ERROR',
    START_VOD_PLAYBACK: 'START_VOD_PLAYBACK',
    OFFER_SELECTED: 'OFFER_SELECTED',
    VOD_UPSELL: 'VOD_UPSELL',
    PERFORM_PC_CHECK: 'PERFORM_PC_CHECK',
    PC_CHECK_SUCCESS: 'PC_CHECK_SUCCESS',
    PURCHASE_ERROR: 'PURCHASE_ERROR',
    SHOW_FORMAT_SELECTOR: 'SHOW_FORMAT_SELECTOR',
    FORMAT_SELECTOR_KEY_OK: 'FORMAT_SELECTOR_KEY_OK',
    FORMAT_SELECTOR_MOUSE_CLICK: 'FORMAT_SELECTOR_MOUSE_CLICK',
    VOD_RESUME_OVERLAY_KEY_OK: 'VOD_RESUME_OVERLAY_KEY_OK',
    VOD_RESUME_OVERLAY_MOUSE_CLICK: 'VOD_RESUME_OVERLAY_MOUSE_CLICK',
} as const;

type TVodPlayActionStateType =
    (typeof TVodPlayActionStateType)[keyof typeof TVodPlayActionStateType];

export type TVodPlayActionState =
    | { type: typeof TVodPlayActionStateType.INIT; vodRequiredParams: VodRequiredParams }
    | { type: typeof TVodPlayActionStateType.ERROR; error: VodPlayActionError }
    | {
          type: typeof TVodPlayActionStateType.START_VOD_PLAYBACK;
          selectedAction: TVodWatchAction;
          isStartOver: boolean;
      }
    | { type: typeof TVodPlayActionStateType.OFFER_SELECTED; selectedAction: TVodWatchAction }
    | { type: typeof TVodPlayActionStateType.VOD_UPSELL; selectedAction: TVodWatchAction }
    | { type: typeof TVodPlayActionStateType.PERFORM_PC_CHECK; selectedAction: TVodWatchAction }
    | { type: typeof TVodPlayActionStateType.PC_CHECK_SUCCESS; selectedAction: TVodWatchAction }
    | { type: typeof TVodPlayActionStateType.PURCHASE_ERROR; error: VodPlayActionError }
    | { type: typeof TVodPlayActionStateType.SHOW_FORMAT_SELECTOR }
    | { type: typeof TVodPlayActionStateType.FORMAT_SELECTOR_MOUSE_CLICK }
    | { type: typeof TVodPlayActionStateType.FORMAT_SELECTOR_KEY_OK }
    | { type: typeof TVodPlayActionStateType.VOD_RESUME_OVERLAY_KEY_OK }
    | { type: typeof TVodPlayActionStateType.VOD_RESUME_OVERLAY_MOUSE_CLICK };
